import { useEffect, useRef, useState } from 'react';
import { getMemory } from '../../lib/use-cases/get-memory';
import { logError } from '../../lib/shared/error-logger';

const MEMORY_POLL_INTERVAL = 3000;
const NOT_FOUND_STATUS = 404;

function isMemoryNotReady(error) {
    return error?.statusCode === NOT_FOUND_STATUS || error?.status === NOT_FOUND_STATUS;
}

function useMemory({ chapter, isOpen }) {
    const [memory, setMemory] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const pollTimeoutRef = useRef(null);

    useEffect(() => {
        if (!isOpen || !chapter) {
            return undefined;
        }

        let isCancelled = false;

        setMemory(null);
        setIsLoading(true);

        const poll = async () => {
            try {
                const data = await getMemory(chapter);

                if (isCancelled) {
                    return;
                }

                setMemory(data);
                setIsLoading(false);
            } catch (error) {
                if (isCancelled) {
                    return;
                }

                if (isMemoryNotReady(error)) {
                    pollTimeoutRef.current = setTimeout(poll, MEMORY_POLL_INTERVAL);

                    return;
                }

                logError(error);
                setIsLoading(false);
            }
        };

        poll();

        return () => {
            isCancelled = true;
            clearTimeout(pollTimeoutRef.current);
        };
    }, [chapter, isOpen]);

    return {
        memory,
        isLoading
    };
}

export {
    useMemory
};
